import React from 'react'
import LoginForm from '../components/page-component/LoginForm'

export default function login() {
  return (
    <LoginForm/>
  )
}
